<template>
    <header class="top-bar">
      <div class="wrap">
        <span>欢迎来到<span>大日化</span>!</span>
        <div class="menus">
          <span v-if="isLogin">
            <span>您好，{{userInfo.account}}</span>
            <el-button type="text" style="margin-left: 8px;" @click="loginout">退出</el-button>
          </span>
          <span v-else>
            <!--<my-link href="/login" style="margin-left: 8px;">登录</my-link>-->
            <a style="cursor: pointer;" @click="popLogin" underline="underline" disabled="disabled"
               icon="icon">
              登录
            </a>
            <my-link href="/register" style="margin-left: 8px;">注册</my-link>
          </span>
          <el-divider v-if="!vipInfo || !vipInfo.vipEdate" direction="vertical"></el-divider>
          <my-link v-if="!vipInfo || !vipInfo.vipEdate" href="/userCenter/vipLevel">开通会员</my-link>
          <el-divider direction="vertical"></el-divider>
          <my-link href="/userCenter/myCenter">个人中心</my-link>
         <!--
         <el-divider direction="vertical"></el-divider>
          <a href="http://platform.darihua.com" target="_blank">大日化工作台</a>
          <el-divider direction="vertical"></el-divider>
          <a href="http://org.darihua.com" target="_blank">检测机构工作台</a>
          -->
        </div>
      </div>
    </header>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'topBar',
  data: function () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  methods: {
    ...mapActions(['handleLogOut']),
    popLogin () {
      // 判断是都需要登录才能访问
      this.$login({
        next: function () {},
        to: 'home'
      })
    },
    loginout () {
      this.$store.dispatch('handleLogOut').then((res) => {
        this.logining = false
        if (res.rtnCode === '0') {
          this.$router.push({
            name: 'home'
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .top-bar{
    min-width: 1226px;
    font-size: 14px;
    background: #E3E4E5;
    height: 40px;
    width: 100%;
    font-weight: 400;
    line-height: 40px;
    .menus {
      float: right;
      height: 40px;
    }
    span {
      margin: 0 5px;
      color: #9C9C9C;
      span{
        color: #32A08C;
        font-weight: bold;
      }
    }
    a{
      color: #9C9C9C;
      text-decoration: none;
      &:hover{
        color: #32A08C;
        font-weight: bold;
      }
    }
  }
</style>
